import TransacoesPage from './TransacoesPage';
export default function FinancasEntradas() {
  return <TransacoesPage tipo="entrada" titulo="Entradas" descricao="Vendas, recebimentos e receitas" />;
}
